import { createAsyncThunk } from '@reduxjs/toolkit'
import { SOMETHING_WHEN_WRONG } from 'constant/errorMessages'
import {
  deleteDirectPutawayUnassignStaffAPI,
  getDirectPutawayDetailAPI,
  getDirectPutawayItemByTaskIdAPI,
  GetDirectPutawayItemByTaskIdResponseType,
} from 'features/PurchaseOrder/services/directPutaway'
import { callErrorMsg } from 'helpers/errorMsg'
import { toastSuccess } from 'utils/toast'

export const SLICE_NAME = 'directPutawayDetailSlice'

export const fetchGetDirectPutawayDetail = createAsyncThunk(
  `${SLICE_NAME}/fetchGetDirectPutawayDetail`,
  async (id: number, { rejectWithValue }) => {
    try {
      const res = await getDirectPutawayDetailAPI(id)

      return res.data.data
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)

export const fetchGetDirectPutawayItemByTaskId = createAsyncThunk(
  `${SLICE_NAME}/fetchGetDirectPutawayItemByTaskId`,
  async (
    arg: {
      id: number
      params?: Parameters<typeof getDirectPutawayItemByTaskIdAPI>[1]
    },
    { getState, rejectWithValue },
  ) => {
    try {
      const { id, params } = arg

      const { directPutawayDetailV2 } = getState() as StoreStateType

      const qs = { ...directPutawayDetailV2.query, ...params }
      const cleanQs = Object.fromEntries(
        Object.entries(qs).filter(([_, v]) => v !== '' && v != null),
      )

      const res = await getDirectPutawayItemByTaskIdAPI(id, cleanQs)

      const result: GetDirectPutawayItemByTaskIdResponseType = {
        data: res.data.data,
        pagination: res.data.pagination,
      }

      return result
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)

export const fetchDeleteDirectPutawayUnassignStaff = createAsyncThunk(
  `${SLICE_NAME}/fetchGetDirectPutawayUnassignStaff`,
  async (id: number, { rejectWithValue, dispatch }) => {
    try {
      const res = await deleteDirectPutawayUnassignStaffAPI(id)

      toastSuccess(res.data.message)

      dispatch(fetchGetDirectPutawayDetail(id))
      dispatch(fetchGetDirectPutawayItemByTaskId({ id }))

      return res.data.message
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)
